import { render } from "./AverageGraduationTimeByProgram.vue?vue&type=template&id=056fdfd6"
import script from "./AverageGraduationTimeByProgram.vue?vue&type=script&lang=js"
export * from "./AverageGraduationTimeByProgram.vue?vue&type=script&lang=js"
script.render = render

export default script